import React from 'react'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { CurrencyText } from '../../common/components/CurrencyText'

interface CashflowAmountHeadingProps {
  amount: number
  isMobile?: boolean
  isTotal?: boolean
  label: string
  symbol?: string
  tooltip?: React.ReactNode
}

const CashflowAmountHeading: React.FC<CashflowAmountHeadingProps> = ({
  amount,
  isMobile = false,
  isTotal = false,
  label,
  symbol,
  tooltip,
}) => {
  return (
    <Stack
      bgcolor={isTotal ? 'background.default' : 'transparent'}
      direction={isMobile ? 'row' : 'column'}
      justifyContent={isMobile ? 'space-between' : 'initial'}
      padding={isMobile ? '14px 16px' : 0}
      sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}
    >
      {!isMobile && <CurrencyText amount={amount} component="h2" variant="h2" />}
      <Stack alignItems="center" component="span" direction="row" gap={8} mt={2}>
        <Text bold={isTotal} variant="body2">
          {label}
        </Text>
        {tooltip}
      </Stack>
      {isMobile && <CurrencyText amount={amount} component="h2" symbol={symbol} variant="body2" />}
    </Stack>
  )
}

export default CashflowAmountHeading
